var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { GATEWAY_URL } from '../../utils/common/apiConfig';
import httpPost from '../../utils/http/httpPost';
/**
 * 헤더에 토큰을 담아서 자동로그인을 요청합니다.
 * @param requestParameter: 요청 파라미터
 * @param requestConfig: axios 요청 설정
 */
var fetchAutoLogin = function (requestParameter, requestConfig) {
    var userToken = requestParameter.userToken, lastPasswordUpdateDate = requestParameter.lastPasswordUpdateDate, deviceId = requestParameter.deviceId, deviceModel = requestParameter.deviceModel, deviceName = requestParameter.deviceName;
    var headers = {
        Authorization: "Bearer ".concat(encodeURIComponent(userToken)),
        'Last-Password-Update-Date': lastPasswordUpdateDate,
    };
    var requestBodyParams = JSON.stringify({
        deviceId: deviceId,
        deviceName: deviceName,
        deviceModel: deviceModel,
    });
    var filledRequestConfig = __assign(__assign({}, requestConfig), { headers: headers, data: requestBodyParams });
    return httpPost("".concat(GATEWAY_URL).concat(API_URLS.AUTO_LOGIN), filledRequestConfig)
        .then(function (response) {
        return response;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchAutoLogin;
